import { useTranslation } from 'react-i18next'

import { Alert, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StripeSettings = ({ isConnected }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="bodyMRegular">
        {t(
          'Conecta Reveni con tu cuenta de Stripe para poder procesar los pagos de tus clientes cuando soliciten cambios por otros productos.'
        )}
      </Text>
      {isConnected && (
        <Styles.StatusContainer>
          <Alert type="success" size="m">
            {t('Conectado')}
          </Alert>
        </Styles.StatusContainer>
      )}
    </Styles.Container>
  )
}

export default StripeSettings
